import $ from 'jquery';

class UserRatesRepository {
    constructor(data) {
        this.endpoints = data.endpoints;
        this.data = data.data;
    }
    load() {
        const request = (resolve, reject) => {
            $.get(this.endpoints.user)
                .done(response => {
                    const { status, data, redirectURL } = response;

                    if (status === 'ok') {
                        resolve(data);
                    } else if (status === 'error') {
                        reject(data.error);
                    } else if (status === 'redirect') {
                        window.location.href = redirectURL;
                    }
                })
                .fail(error => {
                    reject(error);
                });
        };
        return new Promise(request);
    }
    vote(payload) {
        const request = (resolve, reject) => {
            $.post(this.endpoints.vote, payload)
                .done(response => {
                    const { status, data, redirectURL } = response;

                    if (status === 'ok') {
                        resolve(data);
                    } else if (status === 'error') {
                        reject(data.error);
                    } else if (status === 'redirect') {
                        window.location.href = redirectURL;
                    }
                })
                .fail(error => {
                    reject(error);
                });
        };
        return new Promise(request);
    }
}

export default UserRatesRepository;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/user-rates/repository.js